import React from 'react'
import { LazyLoadComponent } from 'react-lazy-load-image-component'
import styled from 'styled-components'
import { Link } from 'gatsby'

import ItemizedReviewList from '../../../organisms/ItemizedReviewList'
import RecommendList from '../../../organisms/RecommendList'
import { MysqlProducts, MysqlRanksEdge, MysqlSurveyQuestionsEdge } from '../../../graphqlTypes'

const Container = styled.li`
  margin: 26px 0 0;
  padding: 0 7px;
  width: calc(100% / 3);
  &:first-child {
    border-bottom: 1px solid ${({ theme }) => theme.palette.border.light};
    margin: 0;
    padding: 0 0 40px;
    width: 100%;
  }
`

const ProductInfoContainer = styled.div`
  color: ${({ theme }) => theme.palette.font.main};
  font-weight: bold;
  margin: 0 0 0 15px;
`

const Manufacturer = styled.p`
  font-size: 14px;
  line-height: 14px;
  margin: 0 0 8px;
`

const ProductName = styled.p`
  font-size: 18px;
  line-height: 22px;
`

const FirstRankHeading = styled.div`
  align-items: center;
  display: flex;
`

const EmblemImage = styled.img`
  width: 96px;
  height: 96px;
`

const ProductContainer = styled.div`
  align-items: flex-start;
  display: flex;
  margin: 18px 0 0;
`

const ProductReview = styled.div`
  flex: 1;
  margin: 0 0 0 20px;
`

const Label = styled.label`
  color: ${({ theme }) => theme.palette.font.dark};
  display: inline-block;
  margin: 28px 0 7px;
  font-size: 14px;
  font-weight: bold;
`

const ImageFrame = styled(Link)`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  text-decoration: none;
  width: 280px;
  height: 280px;
`

const Image = styled.img`
  object-fit: contain;
  width: 100%;
  height: 100%;
  max-width: 280px;
  max-height: 280px;
`

type Props = {
  rank: MysqlRanksEdge
  surveyQuestions: MysqlSurveyQuestionsEdge[]
}

export default function GrandAwardItem({ rank, surveyQuestions }: Props) {
  const product = rank.node.products!

  return (
    <Container>
      <FirstRankHeading>
        <LazyLoadComponent>
          <EmblemImage
            alt={'ママリ口コミ大賞 大賞エンブレム画像'}
            src={`${product.fields!.grandAwardImageUrl}?auto=format&w=192&h=192`}
            decoding={'async'}
          />
        </LazyLoadComponent>
        <ProductInfoContainer>
          {product.manufacturer && <Manufacturer>{product.manufacturer}</Manufacturer>}
          <ProductName>{product.name}</ProductName>
        </ProductInfoContainer>
      </FirstRankHeading>
      <ProductContainer>
        <ImageFrame to={product.fields!.pagePath!}>
          <Image
            alt={product.name!}
            src={`${product.fields!.imageUrl}?auto=format&fit=clip&w=560&h=560`}
            decoding={'async'}
          />
        </ImageFrame>
        <ProductReview>
          <RecommendList product={product as MysqlProducts} />
          <Label>項目別評価</Label>
          <ItemizedReviewList rank={rank} surveyQuestions={surveyQuestions} />
        </ProductReview>
      </ProductContainer>
    </Container>
  )
}
